export const storybookExcludedControlParams = [
  'aria-label',
  'aria-labelledby',
  'aria-describedby',
  'onFilter',
  'onClear',
  'onChange',
  'onClick',
  'ref',
  'className',
  'usePortal',
  'portalClassName',
  'portalContainer',
  'scrollContainer',
  'popoverZIndex',
  'id',
];
